import { render, staticRenderFns } from "./CategorySettingsTab.vue?vue&type=template&id=7c99d708&scoped=true"
import script from "./CategorySettingsTab.vue?vue&type=script&lang=js"
export * from "./CategorySettingsTab.vue?vue&type=script&lang=js"
import style0 from "./CategorySettingsTab.vue?vue&type=style&index=0&id=7c99d708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99d708",
  null
  
)

export default component.exports